import { API_PREFIX } from './constant'
import { ContentType, MultiPartFormData, Request } from './request'

export interface ChainSalesStatistiicsListParams {
    tenantIds?: any
    timeHead?: any
    timeTail?: any
    insuranceCode?: any
    isMerge?: boolean
    payStatus?: any
    tenantSupplierName?: any
}
export function chainSalesStatisticsList(body: ChainSalesStatistiicsListParams): Request {
    return {
        url: `${API_PREFIX}/blade-outpatient/chainRecipe/salesStatistics`,
        method: 'POST',
        body,
    }
}

// 导出
export function chainSalesStatisticsExport(
  body: ChainSalesStatistiicsListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/chainRecipe/salesStatisticsExportExcel`,
    method: 'POST',
    responseType: 'blob',
    body,
  }
}


